import React from 'react';
import { useIntl } from 'react-intl';

import { APPLICANT_TYPES } from '../../configs';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../components/base/BootstrapComponents/BootstrapComponents';

export default function ApplicantSelectType(props) {
  const {
    onClose = () => {},
    onSelectType = () => {},
  } = props;
  const { formatMessage } = useIntl();
  const renderButton = (item, key) => (<Button variant="secondary" key={key} className="" onClick={() => onSelectType(item)}>{formatMessage({ id: `user.type.${item}` })}</Button>);
  return (
    <Dialog
      className="application-select-procedure-dialog"
      onClose={onClose}
      open
    >
      <DialogTitle header="Создать карточку заявителя" title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="application-select-procedure-content">
        <div className="application-select-procedure-column mt-3">{APPLICANT_TYPES.map(renderButton)}</div>
      </DialogContent>
      <DialogFooter>
        <div className="hff-footer-buttons">
          <Button className="hff-clear-data" variant="secondary" onClick={onClose}>Отменить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
